import { Pipe, PipeTransform } from '@angular/core';

import { TeamListModel } from '@ninety/mobile/platform/api';

@Pipe({
  name: 'findTeamById',
  pure: true,
})
export class FindTeamByIdPipe implements PipeTransform {
  transform(value: TeamListModel[], id: string): TeamListModel | null {
    if (!Array.isArray(value)) return null;
    if (!id) return null;
    return value.find(team => team._id === id) ?? null;
  }
}
